import React, { useEffect, useState } from "react";
import { CheckSuccessIcon, FailedIcon } from "@components/library";
import { useLocation } from "react-router-dom";
import { useTranslation } from "@helpers/translate";
import axios from "@helpers/axios/private.axios";
import "../OndatoPopup/index.sass";

const InlineOndato = ({ onClose }) => {
  const { __ } = useTranslation();
  const [data, setData] = useState({});
  const location = useLocation();
  const [visible, setVisible] = useState(false);

  const checkOndatoVerification = async () => {
    const queryParams = new URLSearchParams(location.search);
    const paramStatus = queryParams.get("status");
    if (paramStatus) {
      try {
        const resp = await axios.get(`/ondato/check`);
        const { status, message } = resp.data;

        setData({
          status: status === "success" ? 2 : 1,
          message,
        });

        setVisible(true);
      } catch (e) {}
    }
  };

  useEffect(() => {
    checkOndatoVerification();
    // intentionally run once on mount
  }, []);

  if (!visible) return null;

  return (
    <div className="ondatoInline">
      <div className="ondatoPopup">
        <div className="ondatoPopup__pic">
          {data.status === 2 ? <CheckSuccessIcon /> : <FailedIcon />}
        </div>
        <h2 className="ondatoPopup__title">
          {data.status === 2 ? __("common.successful") : __("common.failed")}
        </h2>
        <p className="ondatoPopup__text">{data.message}</p>
        <div style={{ marginTop: 12 }}>
          <button
            type="button"
            className="popup__close"
            onClick={() => {
              setVisible(false);
              if (onClose) onClose();
            }}
          >
            Close
          </button>
        </div>
      </div>
    </div>
  );
};

export default InlineOndato;
